"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// checks if a cabin in the basket has an insurance
function hasInsurance(state, getters) {
    for (var _i = 0, _a = state.basket; _i < _a.length; _i++) {
        var cabin = _a[_i];
        var insurance = getters[cabin + '/insurance/selection'];
        if (insurance && insurance !== 'NONE') {
            return true;
        }
    }
    return false;
}
exports.default = hasInsurance;
//# sourceMappingURL=hasInsurance.js.map